/** External legal / policy pages (Explore). */
export const EXPLORE_PRIVACY_POLICY_URL = 'https://kiddoware.com/explore-privacy-policy/';
/** Shorter summary — linked near the search box for learners. */
export const EXPLORE_PRIVACY_POLICY_SUMMARY_URL =
  'https://kiddoware.com/explore-privacy-policy-summary/';
